export default async function getWallet() {
    let state = {auth: false};
    
    if (window.tronWeb || (window.tronLink && window.tronLink.tronWeb)) {
        if (!window.tronWeb && window.tronLink && window.tronLink.tronWeb)  {
            window.tronWeb = window.tronLink.tronWeb;
        }

        let ok = false;
        if (window.tronLink) {
            const check = await window.tronLink.request({method: 'tron_requestAccounts'});
            ok = check.code === 200;
        } else {
            ok = window.tronWeb.defaultAddress.base58 && true;
        }
        if (ok) {
            let tempBalance = await getBalance();
            if (!tempBalance.balance) tempBalance.balance = 0;
            state.auth = true;
            state.login = true
            state.name = window.tronWeb.defaultAddress.name ?? '';
            state.balance = tempBalance.balance / 1000000;
            state.network = window.tronWeb.fullNode.host;
            state.address = window.tronWeb.defaultAddress.base58;
            state.eventServer = window.tronWeb.eventServer.host;
            state.fullNode = window.tronWeb.fullNode.host;
            state.solidityNode = window.tronWeb.solidityNode.host;
            state.timer = true;
        }
    }

    return state;
}

const getBalance = async () => {
    return await window.tronWeb.trx.getAccount(
        window.tronWeb.defaultAddress.base58
    );
};
